import { isCookieAuthToken } from './browserSession';
import { IS_NATIVE_APP } from '../utils/platform';

const STORAGE_KEY = 'bes_auth_session_v1';
const SHOULD_PERSIST = process.env.NODE_ENV === 'test' || IS_NATIVE_APP;

let currentSession = null;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(currentSession);
    } catch (_error) {
      // Ignore listener errors to avoid breaking updates.
    }
  });
}

function safeParse(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_error) {
    return null;
  }
}

function loadSessionFromStorage() {
  if (!SHOULD_PERSIST || typeof window === 'undefined') return null;
  const storage = IS_NATIVE_APP ? window.localStorage : window.sessionStorage;
  const nextSession = safeParse(storage.getItem(STORAGE_KEY));

  if (IS_NATIVE_APP && isCookieAuthToken(nextSession?.accessToken)) {
    storage.removeItem(STORAGE_KEY);
    return null;
  }

  return nextSession;
}

function persistSession(session) {
  if (typeof window === 'undefined') return;
  const storage = IS_NATIVE_APP ? window.localStorage : window.sessionStorage;
  if (!session) {
    storage.removeItem(STORAGE_KEY);
    return;
  }
  if (!SHOULD_PERSIST) {
    return;
  }
  storage.setItem(STORAGE_KEY, JSON.stringify(session));
}

currentSession = loadSessionFromStorage();

export function getAuthSession() {
  return currentSession;
}

export function setAuthSession(nextSession) {
  currentSession = nextSession || null;
  persistSession(currentSession);
  notify();
}

export function clearAuthSession() {
  setAuthSession(null);
}

export function subscribeAuthSession(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
